import RegisterForm from "../../components/UserManagement/RegisterForm";

export default function Register() {
  return <RegisterForm />;
}
